import { DSpacer } from './styles';

export default DSpacer;
